export default "__VITE_ASSET__DDgD1EJw__"